import React, { useState, useEffect } from "react";
import styled from "styled-components";

import useConfigs from "../hooks/useConfigs";
import useThemes from "../hooks/useThemes";
import { fetchListaConfiguracion } from "../services/parameter.service";
import Hero from "./HeroSection/Hero";

export const PageProveedores = () => {
  window.scroll(0, 0)
  const { backgroundWhite, colorSecundario, colorCuarto } = useThemes();
  const { fontSizeMultiplier } = useConfigs();

  const [urlProveedores, setUrlProveedores] = useState(null);

  const getUrl = async () => {
    try {
      const response = await fetchListaConfiguracion({
        key: "URL_PROVEEDORES",
      });
      setUrlProveedores(response.data.list[0]?.value);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <Container
      background={backgroundWhite}
      colortitulo={colorSecundario}
      color={colorCuarto}
      fontsizemultiplier={fontSizeMultiplier}
    >
      {/* <Hero
        title="Proveedores"
        subtitle="INGRESO AL PORTAL DE RADICACIÓN DE FACTURAS"
        imgSrc="img/Servicios/provedores.jpg"
        color={backgroundWhite}
      /> */}

      <div className="iframe-container">
        <iframe
          src={urlProveedores}
          title="login proveedores"
          frameborder="0"
        ></iframe>
      </div>

      <div className="text-container">
        <p className="title">¿Soporte?</p>
        <p className="texto">direccionoperativa@famedicips.com</p>
        <p className="texto">radicacion@famedicips.com</p>
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding-bottom: 3rem;
  background-color: ${(props) => props.background};
  padding-top: 3rem !important;

  @media (max-width: 1023px) {
    padding-top: 8rem !important;
  }

  .iframe-container {
    iframe {
      width: 100%;
      height: 100%;
    }
  }

  .text-container {
    text-align: center;

    .title {
      font-size: ${(props) => 50 * props.fontsizemultiplier};
      font-weight: 700;
      color: ${(props) => props.colortitulo};
    }

    .texto {
      font-size: ${(props) => 15 * props.fontsizemultiplier};
      margin-bottom: 0;
      color: ${(props) => props.color};
    }
  }
`;
